// extracted by mini-css-extract-plugin
export default {"header":"purchase-section_header__+GqZs"};